// !! NOTICE, BACK-END !! //
// ------------------------------------------------------------------------------------ //
// Data is loaded via endpoints specified in optionsDataPath and communityDataPath      //
// optionsDataPath will be used on load to populate state, then metro, then community.  //
// An ajax call is used after each selection to the same endpoint to populate the       //
// next field, simply update the data at that endpoint.                                 //
// ------------------------------------------------------------------------------------ //
// After selecting Get Directions on the front end, use the communityDataPath endpoint  //
// to get the community data, see the communitySelect method below. Set this path to    //
// whichever url will pull a community via id.                                          //
// ------------------------------------------------------------------------------------ //
// You're probably going to need to change the endpoint path                            //
// ------------------------------------------------------------------------------------ //



$(function () {

  if ($('#driving-directions').length) {
    var app = window.app = new Vue({
      delimiters: ['{{', '}}'],
      data: {
        'showDirections': false,
        'community': null,
        'stateSelect': "",
        'metroSelect': "",
        'communitySelect': "",
        'options': {
          communities: null,
          metros: null,
          states: null
        },
        'location': {
          lat: 33.4484,
          lng: -112.0740
        },
        'mapLink': null
      },

      computed: {
        optionsDataPath: function () {
          var prod;
          // Gulp proprocessor
          prod = true;
          return prod ?
            "/api/sitecore/drivingdirections/directionsoptions" :
            "/data/directionsOptions.json";
        },
        communityDataPath: function () {
          var prod;
          // Gulp proprocessor
          prod = true;
          return prod ?
            "/api/sitecore/drivingdirections/communities" :
            "/data/communities.json";
        },
        showResults: function () {
          // Watches for all fields to be selected before showing directions
          return this.stateSelect && this.metroSelect && this.communitySelect ? true : false;
        },
        urlParams: function () {
          var params = this.getURLParam();
          return params;
        }
      },

      watch: {
        stateSelect: function () {
          // Reset inputs after this one if they're not already empty
          if (this.stateSelect !== "") {
            if (this.getURLParam().state !== this.stateSelect) {
              this.metroSelect = "";
              this.communitySelect = "";
            }
            this.setURLParameter('state', this.stateSelect);

          } else {
            this.removeURLParameter('state');
            this.removeURLParameter('metro');
            this.removeURLParameter('community');
          }

          this.getMetros();
          this.showDirections = false;
        },
        metroSelect: function () {
          // Reset inputs after this one if they're not already empty
          if (this.metroSelect !== "") {
            if (this.getURLParam().metro !== this.metroSelect) {
              this.communitySelect = "";
            }

            this.setURLParameter('metro', this.metroSelect);
          } else {
            this.removeURLParameter('metro');
            this.removeURLParameter('community');
          }

          this.getCommunities();
          this.showDirections = false;
        },
        communitySelect: function () {
          if (this.communitySelect !== "") {
            this.setURLParameter('community', this.communitySelect);
            this.getCommunity();
          } else {
            this.removeURLParameter('community');
          }
        }
      },

      methods: {
        getDirections: function () {
          var self = this;
          if (this.stateSelect === "" || this.metroSelect === "" || this.communitySelect === "") {
            return false;
          }
          if (this.community && 'community_salesCenter' in this.community) {
            this.location = {
              lat: this.community.community_salesCenter.salesCenter_latitude,
              lng: this.community.community_salesCenter.salesCenter_longitude
            };
          }

          this.showDirections = true;
          setTimeout(function () {
            self.initMap();
            if ($(window).width() >= 1024) {
              $('html,body').animate({
                scrollTop: $('#driving-directions--location').offset().top - $('.nav--main').outerHeight()
              }, 'slow');
            } else {
              $('html,body').animate({
                scrollTop: $('#driving-directions--location').offset().top - $('.nav--bottom').outerHeight()
              }, 'slow');
            }
          }, 100);
        },
        resetFilters: function () {
          this.showDirections = false;
          this.stateSelect = "";
          this.metroSelect = "";
          this.communitySelect = "";
        },

        initMap: function () {
          $(window).off('resize');

          // initializes Google maps
          var map, marker;
          map = new google.maps.Map(document.getElementById('directions-map'), {
            scrollwheel: false,
            center: this.location,
            zoom: 14,
            draggable: false
          });
          marker = new google.maps.Marker({
            position: this.location,
            map: map
          });
          google.maps.event.trigger(map, 'resize');
        },

        getStates: function () {
          var self = this;
          $.ajax({
            method: "GET",
            url: self.optionsDataPath
          }).done(function (data) {
            self.options.states = data.states;
          });
        },

        getMetros: function () {
          var self = this;
          $.ajax({
            method: "GET",
            url: self.optionsDataPath,
            data: {
              stateID: self.stateSelect
            }
          }).done(function (data) {
            self.options.metros = data.metros;
          });
        },

        getCommunities: function () {
          var self = this;
          $.ajax({
            method: "GET",
            url: self.optionsDataPath,
            data: {
              metroID: self.metroSelect
            }
          }).done(function (data) {
            self.options.communities = data.communities;
          });
        },

        getCommunity: function () {
          var self = this;
          // Get community based on selected community id
          // Set the community data path
          self.communityDataPath = "/data/communities.json?id=" + app.communitySelect;
          $.ajax({
            method: "GET",
            url: self.communityDataPath,
            data: {
              communityID: self.communitySelect
            }
          }).done(function (data) {
            self.community = data.communities[0];

            var lat = self.community.community_salesCenter.salesCenter_latitude,
              long = self.community.community_salesCenter.salesCenter_longitude;

            // Builds the Google maps directions url
            self.mapLink = "https://www.google.com/maps/dir/Current+Location/" + lat + "+" + long;
          });
        },

        getURLParam: function () {
          // This function is anonymous, is executed immediately and
          // the return value is assigned to QueryString!
          var query_string = {};
          var query = window.location.search.substring(1);
          var vars = query.split("&");
          for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            // If first entry with this name
            if (typeof query_string[pair[0]] === "undefined") {
              query_string[pair[0]] = decodeURIComponent(pair[1]);
              // If second entry with this name
            } else if (typeof query_string[pair[0]] === "string") {
              var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
              query_string[pair[0]] = arr;
              // If third or later entry with this name
            } else {
              query_string[pair[0]].push(decodeURIComponent(pair[1]));
            }
          }
          return query_string;
        },

        checkURLParams: function () {
          this.stateSelect = (typeof this.urlParams.state !== "undefined") ? this.urlParams.state : "";
          this.metroSelect = (typeof this.urlParams.state !== "undefined" && typeof this.urlParams.metro !== "undefined") ? this.urlParams.metro : "";
          this.communitySelect = (typeof this.urlParams.state !== "undefined" && typeof this.urlParams.metro !== "undefined" && typeof this.urlParams.community !== "undefined") ? this.urlParams.community : "";
        },

        setURLParameter: function (name, value) {
          var search;
          if (this.getURLParam()[name]) {
            search = location.search.replace(new RegExp('([?|&]' + name + '=)' + '(.+?)(&|$)'), "$1" + encodeURIComponent(value) + "$3");
          } else if (location.search.length) {
            search = location.search + '&' + name + '=' + encodeURIComponent(value);
          } else {
            search = '?' + name + '=' + encodeURIComponent(value);
          }
          window.history.replaceState({}, document.title, search);
        },

        removeURLParameter: function (parameter) {
          var url = window.location.href;
          var urlparts = url.split('?');
          if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            for (var i = pars.length; i-- > 0;) {
              if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
              }
            }

            url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
            window.history.replaceState({}, document.title, url);
          }
        },
      },

      created: function () {
        var self = this;
        $.get(self.optionsDataPath, function (data) {
          self.options.states = data.states;
        });

        self.checkURLParams();
      },

      mounted: function () {
        $.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyAEGf8jSVepdOwgOpiWNMzJYFIrfPhNipo&async=2&callback=app.initMap");
      }
    });

    app.$mount('#driving-directions');
  }
});